import { SET_PERMISSIONS } from 'redux/actions/types/permissions';

export const setPermissions = payload => ({
    type: SET_PERMISSIONS,
    payload: {
        permissions: { ...payload },
    },
});
